import styled from "styled-components";
import { theme } from "../../../config";

export const LabelStyled = styled.a`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 21px;
  color: ${theme.colors.secondary};

  &:hover {
    color: ${theme.colors.secondary1};
  }

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 12px;
    line-height: 18px;
  }
`;
